import Auth_vue_vue_type_script_setup_true_lang_default from "./Auth.vue_vue_type_script_setup_true_lang.js";
//#region src/views/Settings/Auth.vue
var Auth_default = Auth_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { Auth_default as default };

//# sourceMappingURL=Auth.vue.js.map